import React, { useEffect } from 'react';
export function SitemapXml() {
  useEffect(() => {
    const xml = `<?xml version="1.0" encoding="UTF-8"?>
<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">
  <url>
    <loc>https://ibizaprivatedrivers.com/</loc>
    <changefreq>weekly</changefreq>
    <priority>1.0</priority>
  </url>
  <url>
    <loc>https://ibizaprivatedrivers.com/ibiza-airport-transfer</loc>
    <changefreq>weekly</changefreq>
    <priority>0.9</priority>
  </url>
  <url>
    <loc>https://ibizaprivatedrivers.com/ibiza-villa-transfer</loc>
    <changefreq>weekly</changefreq>
    <priority>0.9</priority>
  </url>
  <url>
    <loc>https://ibizaprivatedrivers.com/ibiza-night-driver</loc>
    <changefreq>weekly</changefreq>
    <priority>0.8</priority>
  </url>
  <url>
    <loc>https://ibizaprivatedrivers.com/ibiza-group-transfer</loc>
    <changefreq>weekly</changefreq>
    <priority>0.8</priority>
  </url>
</urlset>`;
    document.open('text/xml');
    document.write(xml);
    document.close();
  }, []);
  return null;
}